module.exports = __webpack_public_path__ + "082162f96ca6852e18b16b228da9748e.pdf";